import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { GhoreTableUI } from './GhoreTableUI'
import { GhorePrizeTable } from '../ghorePrize/GhorePrizeTable';
//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class GhoreTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetGhore?offset=";
    this.className = "Ghore";
    this.onPrizeClick = this.onPrizeClick.bind(this);

    this.onGhoreClick = this.onGhoreClick.bind(this);
    this.state.mode = "table";
  }

  onGhoreClick(e) {

    if (typeof this.props.onGhoreClick === "function") {
      this.props.onGhoreClick(e);
    }
  }

  onPrizeClick(e) {
    //    console.log(e);
    this.state.mode = "prize";
    this.state.ghoreId = e;

    if (typeof this.props.onPrizeClick === "function") {
      this.props.onPrizeClick(e);
      this.setState({});
    }
  }


  render() {
    if (!this.state.isLoaded) {
      return <div className="box-body"> در حال بارگذاری</div>;
    }
    /*
    if (this.state.mode == 'prize') {
      return <GhorePrizePage ghoreId={this.state.ghoreId} />
    }
    */



    return (
      <div className="container">

        <GhoreTableUI data={this.state.data} onPrizeClick={this.onPrizeClick} onGhoreClick={this.onGhoreClick} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/ghore/GhoreTable.js